<template>
    <h1>Nemáte oprávnění pro vstup do systému</h1>
    <p>Naše databáze neobsahuje vaše údaje nebo nemáte oprávnění pro vstup.</p>
</template>

<script>
export default {

}
</script>

<style>
</style>